import React from "react";
import { Button } from "./ui/button";
import { ArrowRight, Star } from "lucide-react";

const HERO_BG = "https://static.prod-images.emergentagent.com/jobs/25f97584-112a-47b2-84d3-7d9ab16d2f41/images/78d6754c758b36baf6b908767ad4708b0cd9379d0da33356ae33773fc46685f5.png";

export default function Hero({ onBookClick }) {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-br from-black/85 via-black/60 to-black/85" />
      <div
        className="pink-glow-blob"
        style={{ width: 520, height: 520, background: "rgba(255, 32, 121, 0.35)", top: -120, left: -120 }}
      />
      <div
        className="pink-glow-blob"
        style={{ width: 420, height: 420, background: "rgba(255, 32, 121, 0.25)", bottom: -120, right: -80, animationDelay: "2s" }}
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12 items-center pt-32 pb-24">
        <div className="md:col-span-7 space-y-8">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/10 bg-white/5 backdrop-blur-sm">
            <Star className="w-3 h-3 text-[#FF2079] fill-[#FF2079]" />
            <span className="text-[10px] tracking-[0.3em] uppercase text-[#FFB6C1]">
              Award-Winning Studio · Est. 2021
            </span>
          </div>

          <h1
            data-testid="hero-title"
            className="font-display text-5xl sm:text-6xl lg:text-7xl text-white leading-[0.95] tracking-tight"
          >
            Where beauty
            <br />
            <span className="italic text-[#FF2079] [text-shadow:_0_0_60px_rgba(255,32,121,0.4)]">
              glows from within.
            </span>
          </h1>

          <p className="text-base md:text-lg text-[#A09CA3] max-w-xl leading-relaxed">
            A high-end retreat for hair, skin, nails, and body. Indulge in
            personalized rituals crafted by our master artists — designed to
            leave you radiant, restored, and unmistakably you.
          </p>

          <div className="flex flex-wrap gap-4 pt-2">
            <Button
              data-testid="hero-book-btn"
              onClick={onBookClick}
              className="pink-glow-btn bg-[#FF2079] hover:bg-[#D91666] text-white rounded-sm h-12 px-8 text-[11px] tracking-[0.28em] uppercase font-medium group"
            >
              Book Your Ritual
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              data-testid="hero-services-btn"
              variant="outline"
              onClick={() => document.getElementById("services")?.scrollIntoView({ behavior: "smooth" })}
              className="bg-transparent border-white/20 text-white hover:bg-white/5 hover:border-white/40 rounded-sm h-12 px-8 text-[11px] tracking-[0.28em] uppercase font-medium"
            >
              View Services
            </Button>
          </div>

          <div className="flex gap-10 pt-8 border-t border-white/5">
            {[
              { value: "12K+", label: "Happy Guests" },
              { value: "30+", label: "Signature Services" },
              { value: "4.9★", label: "Studio Rating" },
            ].map((stat) => (
              <div key={stat.label}>
                <div className="font-display text-3xl text-white">{stat.value}</div>
                <div className="text-[10px] tracking-[0.25em] uppercase text-[#A09CA3] mt-1">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="hidden md:block md:col-span-5">
          <div className="relative aspect-[3/4] rounded-sm overflow-hidden glass-card">
            <img
              src="https://images.unsplash.com/photo-1740297165018-1431d45d8f11?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHx3b21hbiUyMHNwYSUyMGZhY2lhbCUyMG1hc3NhZ2UlMjByZWxheGluZ3xlbnwwfHx8fDE3Nzg0ODc4NjB8MA&ixlib=rb-4.1.0&q=85"
              alt="Spa ritual"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <div className="eyebrow mb-2">Signature</div>
              <div className="font-display text-2xl text-white">
                Pink Glow Facial
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
